export default "__VITE_ASSET__B9gj8ItL__"